// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gc-migration-modal[data-v-79e2e47c] {\n  position: relative;\n}\n.gc-migration-modal.tomorrow[data-v-79e2e47c] {\n  background: #ebac1e;\n  border: 5px solid #d07022;\n}\n.close-icon[data-v-79e2e47c] {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
